import React from 'react';
import { Grid, Box } from '@material-ui/core';
import { useSelector } from "react-redux";
import AboutTogglebar from './AboutTogglebar';
import ChartView from './ChartView';
import useStyles from './Styles';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';
import toggleIcon from '../../assets/slide-out-icon.png'
import userActions from "./actions";

const CentralArizonaView = () => {
    const classes = useStyles();
    const { chart, toggle_about } = useSelector((state) => state.central_arizona);
    const { windowDimension } = useGetViewPortDimensions();
    const { toggleAboutDrawer } = userActions();

    const about = [{title: "Summary", desc: <p>This map shows all water users—cities, tribes, agriculture, and industry—that have access to Colorado River water in Central Arizona.  The map also shows the percent change in Colorado River water availability at each shortage tier and under more severe scenarios.</p>},
        {title: "Summary", desc: <p>There is an active market for leases and exchanges of Colorado River water in Central Arizona and this creates a difference between access to Colorado River water versus entitlement 
            to Colorado River water.  Water users can have their own entitlement to Colorado River water or rely on someone else’s through leases and exchanges.  This visualization shows entities 
            with the largest <strong>access</strong> to Colorado River water and how available quantities change at each shortage tier and under more severe scenarios. Using the hover tool, a user can see the 
            percent of water available at each priority level. </p>},
        {title: "Summary", desc: <p>For the most part, water users in Western Arizona have rights to Colorado River water that are higher in priority than the Colorado River water delivered into Central Arizona.
            This is why entities in Central Arizona experience cuts to their Colorado River water before water users in Western Arizona.  The Colorado River water delivered into Central 
            Arizona comes with its own priority system.  From lowest to highest priority these are:  Excess & Agriculture, Non-Indian Agricultural (NIA), Municipal & Industrial and Indian, and 
            Priority 3.  An explainer of Arizona’s Colorado River priority system can be found <a target="_blank" href="https://experience.arcgis.com/experience/d74d9265134c44c1ba385796d95769d4/" rel="noopener noreferrer">here</a>. The chart shows the quantity of Colorado River water available for all Central Arizona water 
            users, broken down by priority level, at each shortage tier and under more severe scenarios.</p>}
        ];
    return (
        <Grid container item style={{ height: windowDimension.winHeight - 110, width: windowDimension.winWidth, flexDirection: 'column', zIndex: 1 }}>
            {!toggle_about ? (
            <Grid item>
                <ChartView />
            </Grid>
            ) : (
                <Box className={classes.aboutDrawerResponsive}>
                    <AboutTogglebar about={ chart==="central_arizona_shortage_impacts" ?  about[0] : chart==="allocations" ? about[1] : chart==="shortage_impacts_by_community" ? about[2] : undefined}/>
                </Box>
            )}
            {!toggle_about ? (
                <Grid container item justify="center" alignItems="center" className={classes.aboutTogglebarResponsive} onClick={toggleAboutDrawer}>
                    <img src={toggleIcon} className={classes.aboutToggleIconResponsive} alt="about-icon.png" />
                </Grid>
            ) : null}
        </Grid>
    );
};

export default CentralArizonaView;

